<div class="p-card">
    <div class="p-card-title p-mb-2 p-mt-4" style="font-weight: bold">
        {{ 'home.onboardingProfile.yourInterestsTitle' | translate }}
    </div>
    <div class="p-card-subtitle p-mb-3">
        {{ 'home.onboardingProfile.yourInterestsSubtitle1' | translate }}
        <span style="font-weight: bold">{{ 'home.onboardingProfile.yourInterestsSubtitle2' | translate }}</span>
    </div>

    <app-user-interests-form [user]="currentUser"></app-user-interests-form>
</div>
